module.exports = __webpack_public_path__ + "img/DK36085916.cbf36bc6.svg";